import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule } from '@angular/forms';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';

import { MgFormFieldModule } from '@app/src/app/form-field';

import { CalendarQuickFilterComponent } from './CalendarQuickFilter.component';

export { CalendarQuickFilterComponent };
@NgModule({
  imports: [
    // Minga dependencies
    MgFormFieldModule,

    // External dependencies
    MatSelectModule,
    CommonModule,
    FlexLayoutModule,
    FormsModule,
    MatFormFieldModule,
  ],
  declarations: [CalendarQuickFilterComponent],
  exports: [CalendarQuickFilterComponent],
})
export class CalendarQuickFilterModule {}
